import { SIGNATURE_STATUSES, DEFAULT_SIGNER_ROLE_NAME } from '@/definitions';
import { logWebHrError } from '@/core/logger/log-wrapper';

export const checkSignatureStatus = (providerData) => {
  const { signed, signers: signersJsonString } = providerData;

  let signers = [];
  if (signersJsonString) {
    try {
      signers = JSON.parse(signersJsonString) || [];
    } catch (error) {
      signers = [];
      logWebHrError({
        message: 'Failed to parse signers json string',
        source: 'check-signature-status.js',
        error,
      });
    }
  }

  const matchedSigner = signers.find(
    (s) => s?.role === DEFAULT_SIGNER_ROLE_NAME
  );
  if (matchedSigner?.signatureStatus === SIGNATURE_STATUSES.SIGNED) {
    return true;
  }

  return signed === true || signed === 'true';
};
